import React, { useState, useEffect, useRef } from "react";
import { Helmet } from 'react-helmet';
import SportsIITGNVideo from "../assets/video/IIT Gandhinagar.mp4"
import ImageCarousel from "../components/ImageCarousel";
import { SportsData } from '../data/SportsData';
import { Link } from 'react-router-dom';
import InstagramContainer from "../components/InstagramContainer";
const Home = () => {
  const videoEl = useRef(null);
  const attemptPlay = () => {
    videoEl &&
      videoEl.current &&
      videoEl.current.play().catch(error => {
        console.error("Error attempting to play", error);
      });
  };

  useEffect(() => {
    attemptPlay();
  }, []);

  const [imageUrls] = useState([
    require("../assets/images/banner-1.jpg"),
    require("../assets/images/banner-2.jpg"),
    require("../assets/images/banner-3.jpg"),
  ]);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex(currentIndex => (currentIndex + 1) % imageUrls.length);
    }, 3000);
    return () => clearInterval(intervalId);
  }, [imageUrls]);

  const backgroundImage = imageUrls[currentIndex];



  return (
    <div>
      <Helmet>
        <title>Home | Sports at IITGN </title>
      </Helmet>
      <div className='main-container'>
        <header id="head" style={{
          backgroundImage: `url(${backgroundImage})`,
          transition: "1s ease",
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
          backgroundBlendMode: "overlay",
          flexDirection: "column",
          backgroundRepeat: "space",
        }}>
          <div className="banner-content">
            <h1>Sports at IIT Gandhinagar</h1>
            <h2>Where the mind is withour fear!</h2>
          </div>
        </header>



        <div className="section">

          <div className="about-section">
            <p>
              The IIT Gandhinagar Sports Complex is a world class state-of-the-art facility designed to cater to their sporting and fitness needs of the students, faculty, and staff of the Institute with the intention to promote  a healthy & active lifestyle. The complex is spread over an area of 15 acres and is open to all members of the institute and is also used for various sports events and tournaments throughout the year.
              </p><p>
              The Sports Complex at IIT Gandhinagar also offers coaching and training programs for various sports to help students and staff improve their skills and fitness levels. The facility is managed by a team of qualified and experienced coaches and trainers who provide personalized attention and guidance to each individual.

            </p>
          </div>
        </div>

        <div className="section">
          <div className="section-heading">
            <h1>Recent Events</h1>
          </div>

        </div>
        <ImageCarousel />

        <div className="section">
          <div className="section-heading">
            <h1>Sports</h1>
          </div>
          <div className="grid-4">
            {SportsData.map((Sport, index) => {
              return (
                <div className='home-card-item' key={index}>
                  <Link to={`/sports/${Sport.SportsName}`} onClick={() => window.scrollTo(0, 0)}>
                    <div className="home-card-item-image">
                      <img src={Sport.CardImage} alt='Sports' />

                    </div>
                    <div className="home-card-item-caption">
                      <h2>{Sport.SportsName}</h2>

                    </div>


                  </Link>
                </div>
              )
            })}


          </div>



        </div>


        {/* <div className="section">
          <div className="instagramContainer">
            <div className="section-heading">
              <h1>Sports@IITGN on Instagram</h1>
            </div>

            <InstagramContainer />
          </div>
        </div> */}




        <div className="home-video">
          <video
            style={{ width: "100vw", margin: "0 auto", height: "50vh", maxHeight: "500px", overflow: "hidden", justifyContent: "center", backgroundBlendMode: "overlay", background: "black", objectFit: "cover" }}
            playsInline
            loop
            muted
            controls={false}
            alt="All the devices"
            src={SportsIITGNVideo}
            ref={videoEl}
          />

        </div>


      </div>

    </div>

  )
}

export default Home